import { Grid } from '@material-ui/core'
import Formulaire from 'Components/Formulaire'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import moment from 'moment'
import React from 'react'
import { browserHistory } from 'react-router'
import Search from './Search'


moment.locale('fr')


const viewContact = (row) => {
    browserHistory.push({
        pathname: '/crm/' + row.contact_id,
        state: {}
    })
}

const columns = (showContactLibelle) => [{
    header: 'Id',
    id: 'id',
    show: false,
},{
    header: 'Nom',
    type: 'string',
    id: 'libelle',
   onClick: showContactLibelle && viewContact,
    sortable: false,
       Cell: row => <Grid container wrap={'nowrap'} direction={'column'} justify={'center'} alignItems={'stretch'}
                      alignContent={'center'} style={{ padding: 0, margin: 0, }}>
     {showContactLibelle && <React.Fragment><h4 style={{ padding: '0 5px', margin: 0 }}>{row.contact_libelle}</h4>
         <h5 style={{
           padding: '0 15px',
               margin: 0,
               color: 'grey'
             }}>{row.libelle}</h5>
         </React.Fragment> || <h4>{row.libelle}</h4>}
   </Grid>
},
    {
        header: '',
        type: 'string',
        id: 'status',
        sortable: false,
        Cell: row => <Grid container wrap={'nowrap'} spacing={0} style={{margin: 0, padding: 5}} justify={'center'}
                           alignContent={'center'} alignItems={'center'}>
            <Grid item style={{margin: 0, padding: 5, borderRadius: '50%', backgroundColor: row.status_color}}/>
            <Grid item xs style={{margin: 0, padding: 5}}>
                {row.status}
            </Grid>
        </Grid>
    },
    {
        header: 'Nom',
        type: 'string',
        id: 'libelle',
        sortable: false,
    },
    {
        header: 'Total HT',
        width: 120,
        type: 'int',
        id: 'total_ht',
        sortable: false,
    },
    {
        header: 'Total TVA',
        width: 120,
        type: 'int',
        id: 'total_tva',
        sortable: false,
    },
    {
        header: 'Total TTC',
        width: 120,
        type: 'int',
        id: 'total_ttc',
        sortable: false,
    },
    {
        header: 'Date création',
        width: 120,
        type: 'date',
        id: 'date_creation',
        format: 'DD/MM/YY HH:mm',
        sortable: false,
    },
    {
        header: 'Date expiration',
        width: 120,
        type: 'date',
        id: 'date_expiration',
        format: 'DD/MM/YY HH:mm',
        sortable: false,
    },]

export default React.memo(props => {


    const onClick = async (row) => {
        const responseUrl = await ApiRequest(project.api + 'interface/sellsy', {
            requete: 'document',
            action: 'url',
            document_id: row.id,
            type: row.type
        })
        if (responseUrl && responseUrl.code === 1) {
            window.open(responseUrl.results.url, '_blank')
        }
    }

    return <Formulaire infinityScroll={true}
                       showSearchComponent={props && props.showSearch}
                       searchComponent={props && props.showSearch && <Search
                           defaultSearch={props && props.defaultSearch}
                           searchName={props && props.searchName}
                       />}
                       isAllow={props.isAllow || {}}
                       onClick={props && props.onClick || onClick}
                       maxHeight={props && props.maxHeight}
                       title={props && props.title || false}
                       showForm={false}
                       setAllow={(row) => props.setAllow && props.setAllow(row) || ({})}
                       search={props.search || ((props && props.searchName || 'sellsy_document_') + (props.name || '') + User.Entite.get().id)}
                       module={Constants.module.SELLSY}
                       requete={Constants.donnee.document}
                       columns={columns(props.showContactLibelle)}/>
})


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Interface/Sellsy/index.js